import type { StoneFlickingCoreConfig } from "@cloudnest/stone-flicking-core-engine/types";
import { validateSubmitInput } from "@cloudnest/stone-flicking-core-engine/validators";
import type { SubmitFlickAction } from "../types/actions";
import type { ValidationResult } from "../types/common";
import type { StoneFlickingState } from "../types/game-state";
import { toParticipantId } from "../utils/state-mapper";

export function validateSubmitFlick(
  state: StoneFlickingState,
  action: SubmitFlickAction,
  coreConfig: StoneFlickingCoreConfig,
): ValidationResult {
  return validateSubmitInput(
    state.coreState,
    {
      type: "SUBMIT_INPUT",
      participantId: toParticipantId(action.playerId),
      entityId: action.entityId,
      impulse: action.impulse,
    },
    coreConfig,
  );
}
